<template>
   <div class="layout layout-settings">
      <BreadCrumbs>
         <template #actions>
            <Btn
               :tabindex="-1"
               :text="
                  route.name == 'profile-settings-general'
                     ? 'Save Changes'
                     : 'Update Password'
               "
               action
               type="submit"
               buttonType="small"
               @handleAction="handleSave"
               :disabled="processing"
            >
               <IconSave class="fill" />
            </Btn>
         </template>
      </BreadCrumbs>

      <div class="profile-settings">
         <h1>Settings</h1>
         <Tabs>
            <li>
               <NuxtLink to="/profile/settings/general">General</NuxtLink>
            </li>
            <li>
               <NuxtLink to="/profile/settings/security">Security</NuxtLink>
            </li>
         </Tabs>
      </div>

      <div class="settings-wrapper">
         <NuxtPage />
      </div>
   </div>
</template>
<script setup lang="ts">
import IconSave from "~/assets/images/icons/save-filled.svg?component";
const route = useRoute();
const processing = ref(false);
const hook = useNuxtApp().hook;
const callHook = useNuxtApp().callHook;

const handleSave = async (v) => {
   processing.value = true;
   callHook(
      "form:submit",
      route.name == "profile-settings-general"
         ? "settings-general-form"
         : "settings-security-form"
   );
};

hook("settings:saved", (id) => {
   // console.log('settings:saved', id);
   
   processing.value = false;
});
hook("form:reset", (id) => {
   // console.log('form:reset', id);
   processing.value = false;
});
</script>

<style lang="scss">
div.profile-settings {
   @include px(0, 0, 1);
   h1 {
      padding-top: pad(4);
      padding-bottom: pad(2);
   }
}
div.settings-wrapper {
   // @include mx(0, 0, 1);
   @include py(6);
   background: $background;
   min-height: 25dvh;
}
div.profile-page-settings {
   margin: 0 auto;
   max-width: 600px;
}
</style>
